import { Component, EventEmitter, Output } from "@angular/core";

@Component({
  selector: "app-button-wrapper",
  templateUrl: "./button-wrapper.component.html",
  styleUrls: ["./button-wrapper.component.scss"],
})
export class ButtonWrapperComponent {
  @Output() buttonTrue = new EventEmitter();

  @Output() buttonFalse = new EventEmitter();

  constructor() {}

  public clickButtonTrue() {
    this.buttonTrue.emit();
  }
  public clickButtonFalse() {
    this.buttonFalse.emit();
  }
}
